import React from 'react';

const AboutUs: React.FC = () => {
    return(
        <p>About Us</p>
    )
}

export default AboutUs;

